import {createAction, props} from '@ngrx/store';
import {Update} from '@ngrx/entity';

import {MediaImage, PictureTypeEnum} from './media-image.model';

export const loadMediaImages = createAction(
  '[MediaImage/API] Load MediaImages',
  props<{ mediaImages: MediaImage[] }>()
);

export const addMediaImage = createAction(
  '[MediaImage/API] Add MediaImage',
  props<{ mediaImage: MediaImage }>()
);

export const upsertMediaImage = createAction(
  '[MediaImage/API] Upsert MediaImage',
  props<{ mediaImage: MediaImage }>()
);

export const addMediaImages = createAction(
  '[MediaImage/API] Add MediaImages',
  props<{ mediaImages: MediaImage[] }>()
);

export const upsertMediaImages = createAction(
  '[MediaImage/API] Upsert MediaImages',
  props<{ mediaImages: MediaImage[] }>()
);

export const updateMediaImage = createAction(
  '[MediaImage/API] Update MediaImage',
  props<{ mediaImage: Update<MediaImage> }>()
);

export const updateMediaImages = createAction(
  '[MediaImage/API] Update MediaImages',
  props<{ mediaImages: Update<MediaImage>[] }>()
);

export const deleteMediaImage = createAction(
  '[MediaImage/API] Delete MediaImage',
  props<{ id: string }>()
);

export const deleteMediaImages = createAction(
  '[MediaImage/API] Delete MediaImages',
  props<{ ids: string[] }>()
);

export const clearMediaImages = createAction(
  '[MediaImage/API] Clear MediaImages'
);

// CUSTOM
export const uploadLandingBase64File = createAction(
  '[MediaImage/API] UPLOAD MediaImage',
  props<{ input: any  }>()
);

export const getMediaImages = createAction(
  '[MediaImage/API] get MediaImages',
  props<{ filtering: { pictureType : PictureTypeEnum } }>()
);

export const deleteLandingBase64File = createAction(
  '[MediaImage/API] remove MediaImages',
  props<{ imageUniqueId: string, id: string  }>()
);

export const citizenGetMediaImages = createAction(
  '[MediaImage/API] citizen get MediaImages',
  props<{ filtering: { pictureType : PictureTypeEnum }  }>()
);
